import { inject } from '@angular/core';
import { of } from 'rxjs';
import { findToolStartCommand, getToolStartInput, getToolStartName, Interceptor, PromptResponse } from '@panaya/ai-chat/domain';
import { AiChatThinkingService } from './ai-chat-thinking.service';

export function createUrlBuilderThinkingInterceptor(): Interceptor<PromptResponse> {
    const service = inject(AiChatThinkingService);
    return (response: PromptResponse) => {
        const command = findToolStartCommand(response.commands, (name) => name.startsWith('mcp__url_builder__'));
        if (command) {
            const entity = extractUrlBuilderEntity(getToolStartName(command), getToolStartInput(command));
            service.notifyThinkingEvent({
                state: 'working',
                translationKey: 'aichat.thinking.tools.searching_entity',
                translationParams: { entity }
            });
        }
        return of(response);
    };
}

function extractUrlBuilderEntity(toolName: string, toolInput: string): string {
    const nameMatch = toolName.match(/build_(.+?)_filter_url$/);
    const parsedEntityType = ((): string | null => {
        try {
            return JSON.parse(toolInput)?.request?.entity_type;
        } catch {
            return null;
        }
    })();
    return nameMatch?.[1] ?? (parsedEntityType ? parsedEntityType + 's' : 'items');
}
